import { tabletViewport } from './modules/tabletViewport';
import { smoothScroll } from './modules/smoothScroll';
import { jqHeaderMenu } from './modules/jqHeaderMenu';
//import { jqHeaderHeight } from './modules/jqHeaderHeight';
import { movileTelLink } from './modules/movileTelLink';

import { gaspScrolltrigger } from './modules/gaspScrolltrigger';
import { scrollAnimation } from './modules/scrollAnimation';
import { slider } from './modules/slider';
import { jqAccordion } from './modules/jqAccordion';
import { countNum } from './modules/countNum';
import { pageTop } from './modules/pageTop';


tabletViewport();
smoothScroll();
jqHeaderMenu();
//jqHeaderHeight();
movileTelLink();

gaspScrolltrigger();
scrollAnimation();
slider();
jqAccordion();
countNum();
pageTop();